import { MeetingSummaryHeaderPreset } from '../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS, FOLLOW_UP_EMAIL_PRESET_IDS } from '../../../../../../views/MeetingSummary/CRM/PresetMappings'

const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

export const MEETING_SUMMARY_HEADER_PRESETS: MeetingSummaryHeaderPreset[] = [
  { aiFeaturePresetId: CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS[env], label: 'Tasks', icon: 'bi-check2-square' },
  { aiFeaturePresetId: FOLLOW_UP_EMAIL_PRESET_IDS[env], label: 'Email', icon: 'bi-envelope-at' },
]
